import angular from 'angular';

function lwOnScrollEnd() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      let el = element[0];
      var visibleHeight = el.offsetHeight;
      var scrollableHeight = element.prop('scrollHeight');
      var hiddenContentHeight = scrollableHeight - visibleHeight;
      var threshold = 1000;
      var busy = false;

      let onScroll = () => {
        if (busy) {
          return;
        }

        visibleHeight = el.offsetHeight;
        scrollableHeight = element.prop('scrollHeight');
        hiddenContentHeight = scrollableHeight - visibleHeight;

        if (hiddenContentHeight - el.scrollTop <= threshold) {
          // Scroll is almost at the bottom. Loading more rows
          busy = true;
          scope.$eval(attrs.lwOnScrollEnd).then(() => {
            busy = false;
          });
        }
      }
      scope.$on('$destroy', () => {
        el.removeEventListener('scroll', onScroll)
      })
      el.addEventListener('scroll', onScroll);
    }
  };
}
export default angular.module('directives.lw-on-scroll-end', [])
  .directive('lwOnScrollEnd', lwOnScrollEnd)
  .name;



// WEBPACK FOOTER //
// ./project/directives/lw-on-scroll-end/index.js